<!--
  UpgradeModal — shared cap-hit modal for the 2026 pricing model.
  Shown when a send endpoint returns a structured quota-reached payload
  ({used, limit, plan, type}) or with a custom `message` override.
  The Upgrade CTA is hidden for collaborators and when the entity has
  upgradeCTAVisible === false (agency-managed accounts) — those users get
  a neutral "ask the account owner" line instead.
-->
<template>
  <vs-popup class="holamundo" title="Plan limit reached" :active.sync="activeLocal">
    <p class="text-lg my-2">{{ displayMessage }}</p>
    <vs-button v-if="canUpgrade" class="w-full mt-6" @click="goToPlans">Upgrade</vs-button>
    <p v-else class="mt-6 text-dark">Ask the account owner to upgrade this account to send more invites.</p>
    <vs-divider class="my-4"/>
    <div class="overflow-auto">
      <vs-button type="border" class="float-right" @click="activeLocal = false">Close</vs-button>
    </div>
  </vs-popup>
</template>


<script>
import planConfig from '../planConfig/planConfig.js'

export default {
  name: 'UpgradeModal',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    used: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 0
    },
    //plan key ('free', 'solo_m', ...) or a display name — keys are mapped
    //through planConfig.PLAN_DISPLAY_NAMES, anything else shows as-is
    plan: {
      type: String,
      default: ''
    },
    //'email' | 'text' — accepted for callers that want to record what hit
    //the cap; the pool is shared so the default copy doesn't vary on it
    type: {
      type: String,
      default: ''
    },
    //optional full override of the default "you've used X of Y" sentence
    message: {
      type: String,
      default: ''
    }
  },
  computed: {
    activeLocal: {
      get () {
        return this.active
      },
      set (v) {
        this.$emit('update:active', v)
      }
    },
    planName () {
      if (!this.plan) return 'current'
      return planConfig.PLAN_DISPLAY_NAMES[this.plan] || this.plan
    },
    limitDisplay () {
      if (this.limit === Infinity) return 'Unlimited'
      return this.limit
    },
    displayMessage () {
      if (this.message) return this.message
      return `You've used ${this.used} of ${this.limitDisplay} invites this month on the ${this.planName} plan.`
    },
    canUpgrade () {
      if (this.$store.getters['dash/isCollaborator']) return false
      const business = this.$store.state.dash.viewData.business
      if (business && business.upgradeCTAVisible === false) return false
      return true
    }
  },
  methods: {
    goToPlans () {
      this.activeLocal = false
      this.$router.push('/dash/settings/plan')
    }
  }
}
</script>
